// reducer
import { initialState } from "@/store/MealPlanner/state";

export const addMealToDay = (state, data) => {
  const day = Object.keys(data)[0];

  state.MealPlanner.mealPlan[day] = [
    ...state.MealPlanner.mealPlan[day],
    data[day]
  ];
};

export const updateMondayList = (state, data) => {
  state.MealPlanner.mealPlan.Monday = data;
};

export const updateTuesdayList = (state, data) => {
  state.MealPlanner.mealPlan.Tuesday = data;
};

export const updateWednesdayList = (state, data) => {
  state.MealPlanner.mealPlan.Wednesday = data;
};

export const updateThursdayList = (state, data) => {
  state.MealPlanner.mealPlan.Thursday = data;
};

export const updateFridayList = (state, data) => {
  state.MealPlanner.mealPlan.Friday = data;
};

export const updateSaturdayList = (state, data) => {
  state.MealPlanner.mealPlan.Saturday = data;
};

export const updateSundayList = (state, data) => {
  state.MealPlanner.mealPlan.Sunday = data;
};

export const resetMealDay = state => {
  state.MealPlanner.mealPlan = initialState().mealPlan;
};

export const allPastMealPlans = (state, data) => {
  state.MealPlanner.pastMealPlans = data;
};

export const resetPastMealPlans = state => {
  state.MealPlanner.pastMealPlans = initialState().mealPlan;
};
